export default __webpack_public_path__ + "static/media/07.9543c31a.jpg";